// Translations and labels in pt-BR

export const ROLE_LABEL = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Administrador',
  SUPERVISOR: 'Supervisor',
  ATTENDANT: 'Atendente',
  CLIENT: 'Cliente',
};

export const COMPANY_STATUS_LABEL = {
  ACTIVE: 'Ativa',
  SUSPENDED: 'Suspensa',
  CANCELLED: 'Cancelada',
  TRIAL: 'Trial',
};

export const USER_STATUS_LABEL = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  SUSPENDED: 'Suspenso',
};

export const TICKET_STATUS_LABEL = {
  OPEN: 'Ticket Aberto',
  WAITING_RECEIPT: 'Aguardando Recebimento',
  IN_MAINTENANCE: 'Em Manutenção',
  NO_REPAIR: 'Sem Concerto',
  WAITING_APPROVAL: 'Aguardando Aprovação',
  APPROVED: 'Aprovado',
  REJECTED: 'Reprovado',
  SENT_TO_CLIENT: 'Enviado para Cliente',
  FINALIZED: 'Finalizado',
  CANCELLED: 'Cancelado',
};

export const TICKET_STATUS_COLOR = {
  OPEN: 'bg-blue-100 text-blue-700 border-blue-200',
  WAITING_RECEIPT: 'bg-amber-100 text-amber-700 border-amber-200',
  IN_MAINTENANCE: 'bg-purple-100 text-purple-700 border-purple-200',
  NO_REPAIR: 'bg-zinc-100 text-zinc-700 border-zinc-200',
  WAITING_APPROVAL: 'bg-orange-100 text-orange-700 border-orange-200',
  APPROVED: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  REJECTED: 'bg-red-100 text-red-700 border-red-200',
  SENT_TO_CLIENT: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  FINALIZED: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  CANCELLED: 'bg-zinc-100 text-zinc-500 border-zinc-200',
};

export const PRIORITY_LABEL = {
  LOW: 'Baixa',
  MEDIUM: 'Média',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
};

export const PRIORITY_COLOR = {
  LOW: 'bg-slate-100 text-slate-700 border-slate-200',
  MEDIUM: 'bg-blue-100 text-blue-700 border-blue-200',
  HIGH: 'bg-amber-100 text-amber-800 border-amber-300',
  CRITICAL: 'bg-red-100 text-red-700 border-red-200',
};

export const BR_STATES = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];
